import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useConsumer } from "@/contexts/ConsumerContext";
import { Loader2 } from "lucide-react";

interface ConsumerProtectedRouteProps {
  children: React.ReactNode;
}

const ConsumerProtectedRoute = ({ children }: ConsumerProtectedRouteProps) => {
  const { session, isLoading: authLoading } = useAuth();
  const { isConsumer, isLoading: consumerLoading } = useConsumer();

  if (authLoading || consumerLoading) {
    return (
      <div className="min-h-screen bg-[#080c14] flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#ffd700]" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/consumer/login" replace />;
  }

  if (!isConsumer) {
    return <Navigate to="/consumer" replace />;
  }

  return <>{children}</>;
};

export default ConsumerProtectedRoute;
